var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('input',{staticClass:"knob",attrs:{"type":"text","name":_vm.name,"data-width":"150","data-height":"150","data-thickness":"0.25","data-angleArc":"180","data-angleoffset":"-90","data-bgColor":"#30373e","data-fgColor":"#64c8c0","readonly":""},domProps:{"value":_vm.value}})])
}
var staticRenderFns = []

export { render, staticRenderFns }